import {VarcharDatatypeInterface} from '../postgresql/varchar-datatype.model';

export interface VrsnDataFieldInterface extends VarcharDatatypeInterface {
  data?: string;
}

export class VrsnDataFieldClass extends String
  implements VrsnDataFieldInterface {
  data?: string;
  max_length?: number;
  not_null?: boolean;
  is_unique?: boolean;
  default_value?: string;
}
